var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('case-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('case-details-table')],1),_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('case-content-generation',{staticClass:"mb-2"}),_c('case-prices')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }